import React from 'react'

interface Props {}

const LandingPageStandardQuotes: React.FunctionComponent<Props> = () => {
  return <>LandingPageStandardQuotes</>
}

export default LandingPageStandardQuotes
